import { cn } from '../../../lib/utils'
import { ReactNode } from 'react'

// Semantic aliases map to color variants
export type BadgeVariant = 'green' | 'sky' | 'yellow' | 'red' | 'purple' | 'gray'
  | 'success' | 'info' | 'warning' | 'error'

const ALIAS: Record<string, BadgeVariant> = {
  success: 'green',
  info:    'sky',
  warning: 'yellow',
  error:   'red',
}

const styles: Record<string, string> = {
  green:  'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
  sky:    'bg-sky-500/20 text-sky-400 border-sky-500/30',
  yellow: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
  red:    'bg-red-500/20 text-red-400 border-red-500/30',
  purple: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
  gray:   'bg-white/10 text-white/60 border-white/20',
}

export function GlassBadge({
  children,
  variant = 'sky',
  className,
  dot = false,
}: {
  children: ReactNode
  variant?: BadgeVariant
  className?: string
  dot?: boolean
}) {
  const resolved = ALIAS[variant as string] ?? variant
  const isGreen = resolved === 'green'
  return (
    <span className={cn(
      'inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border',
      styles[resolved],
      className
    )}>
      {dot && (
        <span className={cn(
          'w-1.5 h-1.5 rounded-full',
          isGreen ? 'bg-emerald-400 animate-pulse' : 'bg-current'
        )} />
      )}
      {children}
    </span>
  )
}
